/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum AusschreibungsType {
    Autogenerated = 'Autogenerated',
    Simple = 'Simple',
    Detailliert = 'Detailliert'
  }

    export const AusschreibungsTypeTranslocoMap: Record<AusschreibungsType, string> = {
    [AusschreibungsType.Autogenerated]: 'ausschreibungsType.autogenerated',
    [AusschreibungsType.Simple]: 'ausschreibungsType.simple',
    [AusschreibungsType.Detailliert]: 'ausschreibungsType.detailliert',
    };

    export const AusschreibungsTypeOptions = [
  { value: AusschreibungsType.Autogenerated, labelKey: 'ausschreibungsType.autogenerated' },
  { value: AusschreibungsType.Simple, labelKey: 'ausschreibungsType.simple' },
  { value: AusschreibungsType.Detailliert, labelKey: 'ausschreibungsType.detailliert' },
    ];

